export default function stringifyValues(value, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    separator = ',',
    ignoreNull = true
  } = options;
  if (Array.isArray(value)) {
    return value.join(separator);
  }
  if (typeof value === 'string') {
    return value.replace(/,|\|/gi, separator);
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    // parens are needed for numbers to call toString, or else JS thinks it's a decimal and expects more numbers
    // but parens get stripped out in the build process
    return value + '';
  }
  if (value === null || value === undefined) {
    return ignoreNull ? value : '';
  }
  if (typeof value.toString === 'function') {
    return value.toString();
  }
  return '';
}